export default __webpack_public_path__ + "static/media/card-digital.b32ace90.png";